export default function checkIfNumber(value) {

  if (!value) return '';


  const startsWithZero = value === 0 || (typeof value === 'string' && value.length > 1 && value.charAt(0) === '0');

  const thisNumber = Number(value);
  const isValid = !isNaN(thisNumber);

  if (isValid && startsWithZero && value.length > 1) {
    return value;
  } else if (isValid) {
    return thisNumber;
  }
  return false;
}
